// extracted by mini-css-extract-plugin
export const section = "card-module--section--10gPh";
export const container = "card-module--container--cm6zB";
export const pageContent = "card-module--pageContent--2CMdK";
export const footer = "card-module--footer--2Hx3A";
export const modal = "card-module--modal--25VuP";
export const card = "card-module--card--3VdcU";
export const image = "card-module--image--14kLU";
export const title = "card-module--title--2i0-m";
export const videoWrap = "card-module--videoWrap--AplSm";